
const rel_src_dblquote = /src\s*=\s*\"(?!\/|http)(.+)\"/g;
const rel_src_sngquote = /src\s*=\s*\'(?!\/|http)(.+)\'/g;
const rel_url_dblquote = /url\s*=\s*\"(?!\/|http)(.+)\"/g;
const rel_url_sngquote = /url\s*=\s*\'(?!\/|http)(.+)\'/g;

export default {
    prefixRelativeUrls : function (str, prefix) {
        if (!str) return;
        if (!prefix) return;
        // REGEX 
        // x(?!y)	
        // Matches 'x' only if 'x' is not followed by 'y'. 
        // This is called a negated lookahead.
        // For example, /\d+(?!\.)/ matches a number 
        // only if it is not followed by a decimal point.
        // The regular expression /\d+(?!\.)/.exec("3.141") 
        // matches '141' but not '3.141'.
        // see source [https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Using_parenthesized_substring_matches]
        //const regex=/src="(?!html|\/)(\w+)"/g;
        var ret = str;
        ret = ret.replace(rel_src_dblquote, `src=\"${prefix}$1\"`);
        ret = ret.replace(rel_src_sngquote, `src=\"${prefix}$1\"`);
        ret = ret.replace(rel_url_dblquote, `url=\"${prefix}$1\"`);
        ret = ret.replace(rel_url_sngquote, `url=\"${prefix}$1\"`);
        return ret;
    }
}


// WEBPACK FOOTER //
// ./src/fixUrls.js